import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#3A3229] pt-14 pb-8 bg-[#0A0908]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src="/logo-lineas-doradas.webp" alt="Líneas Doradas S.A.S." className="h-11 w-11 object-contain" />
              <div>
                <div className="font-display text-[19px] text-[#F5EFE0]">Líneas Doradas S.A.S.</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Transporte turístico por toda Colombia</div>
              </div>
            </div>
            <p className="text-sm text-[#F5EFE0]/55 mt-4 max-w-md leading-relaxed">
              Vans, busetas y buses para grupos desde Bogotá hacia toda Colombia. Puntualidad, seguridad y trato cordial en cada viaje.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href="https://www.instagram.com/doradaslineas/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram de Líneas Doradas"
                className="w-10 h-10 rounded-full border border-[#D4AF37]/40 flex items-center justify-center text-[#E8C87A] hover:bg-[#D4AF37] hover:text-[#0A0908]"
                style={{ transitionProperty: "background-color,color,border-color", transitionDuration: "220ms" }}
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.instagram.com/doradaslineas/"
                target="_blank"
                rel="noreferrer"
                className="text-xs text-[#F5EFE0]/60 hover:text-[#E8C87A]"
              >
                @doradaslineas · síguenos
              </a>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#E8C87A] mb-4">Contacto</div>
            <ul className="space-y-3 text-sm text-[#F5EFE0]/75">
              <li className="flex items-center gap-2"><Phone size={14} className="text-[#D4AF37]" /> +57 312 361 6674</li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#D4AF37]" /> transporteenvanesybuses@gmail.com</li>
              <li className="flex items-center gap-2"><MapPin size={14} className="text-[#D4AF37]" /> Bogotá, Colombia</li>
              <li className="flex items-center gap-2">
                <Instagram size={14} className="text-[#D4AF37]" />
                <a href="https://www.instagram.com/doradaslineas/" target="_blank" rel="noreferrer" className="hover:text-[#E8C87A]">
                  @doradaslineas
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#E8C87A] mb-4">Enlaces</div>
            <ul className="space-y-2 text-sm text-[#F5EFE0]/75">
              <li><Link to="/" className="hover:text-[#E8C87A]">Inicio</Link></li>
              <li><Link to="/servicios/aeropuerto-y-tours" className="hover:text-[#E8C87A]">Aeropuerto y Tours</Link></li>
              <li><Link to="/servicios/transporte-turistico-colombia" className="hover:text-[#E8C87A]">Transporte por Colombia</Link></li>
              <li><Link to="/servicios/rutas" className="hover:text-[#E8C87A]">Rutas empresariales</Link></li>
              <li><Link to="/nosotros" className="hover:text-[#E8C87A]">Nosotros</Link></li>
              <li><Link to="/faq" className="hover:text-[#E8C87A]">Preguntas Frecuentes</Link></li>
              <li><Link to="/cotizar" className="hover:text-[#E8C87A]">Cotizar</Link></li>
              <li><Link to="/contacto" className="hover:text-[#E8C87A]">Contacto</Link></li>
              <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#E8C87A]">Panel admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#3A3229] text-xs text-[#F5EFE0]/65 flex flex-wrap justify-between gap-3">
          <div>© {new Date().getFullYear()} Líneas Doradas S.A.S. — Todos los derechos reservados.</div>
          <div>Hecho con detalle en Bogotá.</div>
        </div>
      </div>
    </footer>
  );
}
